import { render, staticRenderFns } from "./CodeAllot.vue?vue&type=template&id=2c20f8b8&scoped=true"
import script from "./CodeAllot.vue?vue&type=script&lang=js"
export * from "./CodeAllot.vue?vue&type=script&lang=js"
import style0 from "./CodeAllot.vue?vue&type=style&index=0&id=2c20f8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20f8b8",
  null
  
)

export default component.exports